import { createPortal } from "react-dom";
import { Button } from "@/components/ui/button";

export default function InterestedArtistsModal({
  isClient,
  interestedModalGig,
  interestedModalArtists,
  isInterestedModalLoading,
  onClose,
  onViewProfile,
  onOpenArtistContact,
}) {
  if (!isClient || !interestedModalGig) {
    return null;
  }
  return createPortal(
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 px-4 py-8"
      onClick={onClose}
    >
      <div
        className="panel-strong max-h-[90vh] w-full max-w-lg overflow-auto p-6"
        onClick={(event) => event.stopPropagation()}
      >
        <div className="flex items-center justify-between">
          <h2 className="text-2xl font-semibold text-slate-900 dark:text-slate-100">
            Interested artists
          </h2>
          <Button type="button" className="btn-secondary" onClick={onClose}>
            Close
          </Button>
        </div>
        {isInterestedModalLoading ? (
          <p className="mt-4 text-sm text-slate-600 dark:text-slate-400">
            Loading…
          </p>
        ) : interestedModalArtists.length === 0 ? (
          <p className="mt-4 text-sm text-slate-600 dark:text-slate-400">
            No artists have marked availability yet.
          </p>
        ) : (
          <div className="mt-4 grid gap-3">
            {interestedModalArtists.map((artist) => (
              <div
                key={artist.id}
                className="rounded-xl border border-slate-200 bg-white p-4 dark:border-slate-700 dark:bg-slate-900"
              >
                <div className="flex items-start justify-between gap-3">
                  <div>
                    <div className="text-sm font-semibold text-slate-900 dark:text-slate-100">
                      {artist.name}
                    </div>
                    <div className="text-xs text-slate-500 dark:text-slate-400">
                      @{artist.username}
                    </div>
                    {artist.genres?.length > 0 && (
                      <div className="mt-2 flex flex-wrap gap-1">
                        {artist.genres.map((g) => (
                          <span
                            key={`${artist.id}-${g}`}
                            className="inline-flex items-center rounded-full bg-slate-100 px-2 py-0.5 text-xs text-slate-700 dark:bg-slate-800 dark:text-slate-200"
                          >
                            {g}
                          </span>
                        ))}
                      </div>
                    )}
                  </div>
                  <div className="flex shrink-0 flex-col gap-2">
                    <Button
                      type="button"
                      className="btn-secondary text-xs"
                      onClick={() => onViewProfile(artist)}
                    >
                      View profile
                    </Button>
                    <Button
                      type="button"
                      className="btn-primary text-xs"
                      onClick={() => {
                        onClose();
                        onOpenArtistContact(artist);
                      }}
                    >
                      Contact
                    </Button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>,
    document.body
  );
}
